<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card :title="$t('Filters')" class="mb-8" collapse-action>
      <div class="vx-row">
        <div class="vx-col lg:w-1/4 md:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t("OrderNumber") }}</label>
          <vs-input 
            :placeholder="$t('SearchByOrderNum')" 
            v-model="keySearch" 
            class="w-full mt-2" 
          />
        </div>

        <div class="vx-col lg:w-1/4 md:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t("Investor") }}</label>
          <vs-select class="w-full mt-2" v-model="filters.InvestorId" :placeholder="$t('Select')">
            <vs-select-item v-for="(item, index) in investorsOptions" :key="index" :value="item.Id" :text="item.InvestorCode" />
          </vs-select>
        </div>

        <div class="vx-col lg:w-1/4 md:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t("Opportunity") }}</label>
          <vs-select class="w-full mt-2" v-model="filters.OpportunityId" :placeholder="$t('Select')">
            <vs-select-item
              v-for="(item, index) in opportunitiesOptions"
              :key="index"
              :value="item.Id"
              :text="currentLocale === 'ar' ? item.OpportunityNameAr : item.OpportunityNameEn" 
            />
          </vs-select>
        </div>

        <div class="vx-col lg:w-1/4 md:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t("Status") }}</label>
          <vs-select class="w-full mt-2" v-model="filters.PurchaseOrderStatusId" :placeholder="$t('Select')">
            <vs-select-item
              v-for="(item, index) in statuses"
              :key="index"
              :value="item.Id"
              :text="currentLocale === 'ar' ? item.NameAr : item.NameEn" 
            />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col flex flex-wrap gap-2">
          <vs-button color="danger" type="border" @click="resetAll">{{ $t("ResetSearch") }}</vs-button>
        </div>
      </div>
    </vx-card>

    <vs-table pagination :max-items="itemsPerPage" search :data="purchaseOrders">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
         <h4 class="ml-4">{{ $t('TotalOrders') }}: {{ purchaseOrders.length }}</h4>

      </div>

      <template slot="thead">
        <vs-th sort-key="PurchaseOrderNumber">{{ $t("OrderNumber") }}</vs-th>
        <vs-th>{{ $t("Investor") }}</vs-th>
        <vs-th>{{ $t("Opportunity") }}</vs-th>
        <vs-th>{{ $t("Tokens") }}</vs-th>
        <vs-th>{{ $t("NetAmount") }}</vs-th>
        <vs-th>{{ $t("Wallet") }}</vs-th>
        <vs-th>{{ $t("Status") }}</vs-th>
        <!-- <vs-th>{{ $t("Actions") }}</vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <tr v-for="(tr, indextr) in data" :key="indextr">
            <vs-td>
              <p class="font-medium">{{ tr.PurchaseOrderNumber }}</p>
            </vs-td>

            <vs-td>{{ tr.InvestorCode || tr.InvestorId }}</vs-td>

            <vs-td>
                {{ currentLocale === 'ar' ? tr.OpportunityNametAr : tr.OpportunityNametEn }}
            </vs-td>

            <vs-td>
               <vs-chip color="primary">{{ tr.RequestedTokensCount }}</vs-chip>
            </vs-td>

            <vs-td>{{ tr.NetAmount.toLocaleString() }}</vs-td>

            <vs-td>
                <p class="text-sm">{{ tr.WalletCode }}</p>
            </vs-td>

            <vs-td>
                <vs-chip :color="getStatusColor(tr.PurchaseOrderStatusId)">
                {{ currentLocale === 'ar' ? tr.StatusNameAr : tr.StatusNameEn || getStatusName(tr.PurchaseOrderStatusId) }}
                </vs-chip>
            </vs-td>

            <!-- <vs-td>
              <div class="flex items-center">
                <vx-tooltip :text="$t('ViewEdit')">
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary cursor-pointer mr-2" @click="$router.push(`/PurchaseOrders/Edit/${tr.Id}`)" />
                </vx-tooltip>
                <vx-tooltip :text="$t('Delete')">
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger cursor-pointer" @click.stop="openConfirm(tr)" />
                </vx-tooltip>
              </div>
            </vs-td> -->
          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import modulePurchaseOrders from "@/store/PurchaseOrders/modulePurchaseOrders.js";
import moduleOpportunities from "@/store/Opportunities/moduleOpportunities.js";
import moduleInvestors from "@/store/Investors/moduleInvestors.js";
export default {
  data() {
    return {
      itemsPerPage: 10,
      keySearch: "",
      filters: {
        OpportunityId: null,
        InvestorId: null,
        PurchaseOrderStatusId: null
      },
      searchTimer: null
    };
  },
  watch: {
    keySearch() { this.debouncedSearch(); },
    filters: {
      handler() { this.debouncedSearch(); },
      deep: true
    }
  },
  computed: {
    currentLocale() { return this.$i18n.locale; },
    opportunitiesOptions() { return this.$store.state.OpportunitiesList.Opportunities; },
    investorsOptions() { return this.$store.state.InvestorsList.Investors || []; }, 
    statuses() { return this.$store.state.PurchaseOrdersList.PurchaseOrderStatus; },
    purchaseOrders() { return this.$store.state.PurchaseOrdersList.PurchaseOrders; },
    Investors() { return this.$store.state.InvestorsList.Investors; }
  },
  methods: {
    getStatusName(statusId) {
      const status = this.statuses.find(s => s.Id === statusId);
      if (status) {
        return this.currentLocale === 'ar' ? status.NameAr : status.NameEn;
      }
      return statusId;
    },
    getStatusColor(id) {
      if (id === 1) return "success"; // مؤكد
      if (id === 2) return "warning"; // قيد التنفيذ
      if (id === 3) return "danger";  // ملغي
      return "primary";
    },
    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("ConfirmDeleteRecord"),
        accept: () => this.deleteData(data),
        acceptText: this.$t("Delete"),
        cancelText: this.$t("Cancel"),
      });
    },
    deleteData(data) {
      this.$store.dispatch("PurchaseOrdersList/removeItem", data.Id)
        .then(() => {
          this.$vs.notify({ color: "success", title: this.$t("Success"), text: this.$t("DeletedSuccessfully") });
        })
        .catch(err => { console.error(err); });
    },
    debouncedSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => { this.applyFilters(); }, 500);
    },
    applyFilters() {
      const payload = {
        OrderNumber: this.keySearch,
        ...this.filters
      };
      this.$store.dispatch("PurchaseOrdersList/fetchFilteredOrders", payload);
    },
    resetAll() {
      this.keySearch = "";
      this.filters = { OpportunityId: null, InvestorId: null, PurchaseOrderStatusId: null };
      this.applyFilters();
    }
  },
  created() {
    // تسجيل الموديولات اللازمة فقط
    if (!modulePurchaseOrders.isRegistered) {
      this.$store.registerModule("PurchaseOrdersList", modulePurchaseOrders);
      modulePurchaseOrders.isRegistered = true;
    }
    if (!moduleOpportunities.isRegistered) {
      this.$store.registerModule("OpportunitiesList", moduleOpportunities);
      moduleOpportunities.isRegistered = true;
    }
 if (!moduleInvestors.isRegistered) {
      this.$store.registerModule("InvestorsList", moduleInvestors);
      moduleInvestors.isRegistered = true;
    }

    this.$store.dispatch("PurchaseOrdersList/fetchPurchaseOrders");
    this.$store.dispatch("PurchaseOrdersList/fetchPurchaseOrderStatus");
    this.$store.dispatch("OpportunitiesList/fetchDataListItems");
    this.$store.dispatch("InvestorsList/fetchDataListItems");
  }
};
</script>

<style lang="scss">

 .icon-container{
    display: flex;
  }
#data-list-list-view small {
  color: rgb(255, 115, 0);
  text-decoration: underline rgb(255, 115, 0);
}

.vxCard:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0%;
  margin-left: 10%;
  z-index: 500000;
  width: 25%;
  height: 20%;
  border-top: 3px solid rgb(255, 115, 0) !important;
  border-bottom: 0 none rgba(255, 0, 0, 0.9) !important;
  border-right: 0 none rgba(255, 0, 0, 0.9) !important;
  border-left: 0 none rgba(0, 0, 0, 0.9) !important;
}
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

    .btn{
      margin-top: 5%;
    }
  }
}
</style>
